import React from 'react';
import CommonPage from './CommonPage';
const Privacy = () => {
  return (
    <CommonPage title="গোপনীয়তা নীতি">
      আমাদের গোপনীয়তা নীতি সম্পর্কে বিস্তারিত শীঘ্রই জানানো হবে।
    </CommonPage>
  );
};
export default Privacy;
